
import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { SignalRTypes, SportTypesActionTypes,SportEventsActionTypes } from '../actions';
import { Enums } from "../../helpers";

export function* requests() {

    yield takeEvery(SignalRTypes.By_Day_week_Days_response, function* ({ response }) {
        try {

            window.console.response("By_Day_week_Days_response", response);

            switch (response.status) {
                case 1:
                    yield put({
                        type: SportEventsActionTypes.Sport_Get_Week_Match_Days_Success,
                        weekMatchDays: response.data,
                    })
                    
                    break;

                case 3:
                    yield put({
                        type: SportEventsActionTypes.Sport_Get_Week_Match_Days_Error,
                        weekMatchDaysError: response.message,
                    })
                    break;

            }

        }
        catch (e) {
            window.log("ERROR", e)

        }
    })
}
export default function* ByDayWeekDaysSaga() {
    yield all([
        fork(requests),
    ])
}
